import React from 'react'
export default function RowBotonesTop(props) {
    return (
        <div className="btn-row">
            {props.children}
        </div>)
}